var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = [`<svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
  <mask id="mask0_2_302" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="39" height="39">
    <rect width="39" height="39" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_2_302)">
    <path d="M17.0623 24.3749H21.9373L21.0029 19.1343C21.5445 18.8634 21.9711 18.4707 22.2826 17.9561C22.594 17.4415 22.7498 16.8728 22.7498 16.2499C22.7498 15.3561 22.4315 14.591 21.7951 13.9546C21.1586 13.3181 20.3935 12.9999 19.4998 12.9999C18.606 12.9999 17.8409 13.3181 17.2044 13.9546C16.568 14.591 16.2498 15.3561 16.2498 16.2499C16.2498 16.8728 16.4055 17.4415 16.7169 17.9561C17.0284 18.4707 17.455 18.8634 17.9966 19.1343L17.0623 24.3749ZM19.4998 35.7499C15.7352 34.802 12.6274 32.6421 10.1763 29.2702C7.72528 25.8983 6.49976 22.154 6.49976 18.0374V8.12488L19.4998 3.24988L32.4998 8.12488V18.0374C32.4998 22.154 31.2742 25.8983 28.8232 29.2702C26.3721 32.6421 23.2643 34.802 19.4998 35.7499ZM19.4998 32.3374C22.3164 31.4436 24.6456 29.6561 26.4873 26.9749C28.3289 24.2936 29.2498 21.3145 29.2498 18.0374V10.3593L19.4998 6.703L9.74976 10.3593V18.0374C9.74976 21.3145 10.6706 24.2936 12.5123 26.9749C14.3539 29.6561 16.6831 31.4436 19.4998 32.3374Z" fill="#00533D"/>
  </g>
</svg>`,
               `<svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
  <mask id="mask0_2_305" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="39" height="39">
    <rect width="39" height="39" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_2_305)">
    <path d="M9.74976 32.5001C8.39559 32.5001 7.24455 32.0262 6.29663 31.0782C5.34871 30.1303 4.87476 28.9793 4.87476 27.6251H1.62476V6.50012H27.6248V13.0001H32.4998L37.3748 19.5001V27.6251H34.1248C34.1248 28.9793 33.6508 30.1303 32.7029 31.0782C31.755 32.0262 30.6039 32.5001 29.2498 32.5001C27.8956 32.5001 26.7445 32.0262 25.7966 31.0782C24.8487 30.1303 24.3748 28.9793 24.3748 27.6251H14.6248C14.6248 28.9793 14.1508 30.1303 13.2029 31.0782C12.255 32.0262 11.1039 32.5001 9.74976 32.5001ZM9.74976 29.2501C10.2102 29.2501 10.5961 29.0944 10.9076 28.7829C11.219 28.4715 11.3748 28.0855 11.3748 27.6251C11.3748 27.1647 11.219 26.7788 10.9076 26.4673C10.5961 26.1558 10.2102 26.0001 9.74976 26.0001C9.28934 26.0001 8.9034 26.1558 8.59194 26.4673C8.28049 26.7788 8.12476 27.1647 8.12476 27.6251C8.12476 28.0855 8.28049 28.4715 8.59194 28.7829C8.9034 29.0944 9.28934 29.2501 9.74976 29.2501ZM4.87476 24.3751H6.17476C6.63517 23.8876 7.1633 23.4949 7.75913 23.197C8.35496 22.8991 9.01851 22.7501 9.74976 22.7501C10.481 22.7501 11.1445 22.8991 11.7404 23.197C12.3362 23.4949 12.8643 23.8876 13.3248 24.3751H24.3748V9.75012H4.87476V24.3751ZM29.2498 29.2501C29.7102 29.2501 30.0961 29.0944 30.4076 28.7829C30.719 28.4715 30.8748 28.0855 30.8748 27.6251C30.8748 27.1647 30.719 26.7788 30.4076 26.4673C30.0961 26.1558 29.7102 26.0001 29.2498 26.0001C28.7893 26.0001 28.4034 26.1558 28.0919 26.4673C27.7805 26.7788 27.6248 27.1647 27.6248 27.6251C27.6248 28.0855 27.7805 28.4715 28.0919 28.7829C28.4034 29.0944 28.7893 29.2501 29.2498 29.2501ZM27.6248 21.1251H34.531L30.8748 16.2501H27.6248V21.1251Z" fill="#00533D"/>
  </g>
</svg>`,
               `<svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
  <mask id="mask0_2_308" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="39" height="39">
    <rect width="39" height="39" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_2_308)">
    <path d="M8.28726 26.0814C7.69142 25.0522 7.24455 23.996 6.94663 22.9126C6.64871 21.8293 6.49976 20.7189 6.49976 19.5814C6.49976 15.9522 7.75913 12.8647 10.2779 10.3189C12.7966 7.77304 15.8706 6.50012 19.4998 6.50012H19.7841L17.1841 3.90012L19.4591 1.62512L25.9591 8.12512L19.4591 14.6251L17.1841 12.3501L19.7841 9.75012H19.4998C16.7914 9.75012 14.4893 10.7048 12.5935 12.6142C10.6977 14.5236 9.74976 16.846 9.74976 19.5814C9.74976 20.2855 9.83101 20.9762 9.99351 21.6532C10.156 22.3303 10.3998 22.9939 10.7248 23.6439L8.28726 26.0814ZM19.5404 37.3751L13.0404 30.8751L19.5404 24.3751L21.8154 26.6501L19.2154 29.2501H19.4998C22.2081 29.2501 24.5102 28.2954 26.406 26.3861C28.3018 24.4767 29.2498 22.1543 29.2498 19.4189C29.2498 18.7147 29.1685 18.0241 29.006 17.347C28.8435 16.6699 28.5998 16.0064 28.2748 15.3564L30.7123 12.9189C31.3081 13.948 31.755 15.0043 32.0529 16.0876C32.3508 17.171 32.4998 18.2814 32.4998 19.4189C32.4998 23.048 31.2404 26.1355 28.7216 28.6814C26.2029 31.2272 23.1289 32.5001 19.4998 32.5001H19.2154L21.8154 35.1001L19.5404 37.3751Z" fill="#00533D"/>
  </g>
</svg>`,
`<svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none">
  <mask id="mask0_2_311" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="39" height="39">
    <rect width="39" height="39" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_2_311)">
    <path d="M14.7468 26.4063L19.4999 23.5219L24.2531 26.4063L22.9937 21.0032L27.2187 17.3469L21.6531 16.9001L19.4999 11.7813L17.3468 16.9001L11.7812 17.3469L16.0062 21.0032L14.7468 26.4063ZM19.4999 37.8626L14.0562 32.5001H6.49995V24.9438L1.13745 19.5001L6.49995 14.0563V6.50007H14.0562L19.4999 1.13757L24.9437 6.50007H32.4999V14.0563L37.8624 19.5001L32.4999 24.9438V32.5001H24.9437L19.4999 37.8626ZM19.4999 33.3126L23.5624 29.2501H29.2499V23.5626L33.3124 19.5001L29.2499 15.4376V9.75007H23.5624L19.4999 5.68757L15.4374 9.75007H9.74995V15.4376L5.68745 19.5001L9.74995 23.5626V29.2501H15.4374L19.4999 33.3126Z" fill="#00533D"/>
  </g>
</svg>`               
];
var badgeTexts = ["Secure Checkout",
                  "Free Shipping",
                  "Return Policy",
                "Warranty and Guarantee"];
var container = document.createElement('div');
container.className = 'simple-badges-outer-container';
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'simple-img-container';
var y = document.querySelectorAll('.product-form__buttons')[0];
if(document.getElementsByClassName('simple-img-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="simple-badge-container">' + imgSrcs[i] +  '<span class="badge'+i+'">'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
    img.className = "simple-badges-container";
           
    
}  
}); 


jQuery(document).ready(function(){
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcss = ['https://trust.conversionbear.com/static/badges/mastercard_color_card.svg','https://trust.conversionbear.com/static/badges/visa_1_color_card.svg','https://trust.conversionbear.com/static/badges/americanexpress_1_color_card.svg','https://trust.conversionbear.com/static/badges/applepay_color_card.svg','https://trust.conversionbear.com/static/badges/shoppay_color_card.svg','https://trust.conversionbear.com/static/badges/venmo_1_color_card.svg','https://trust.conversionbear.com/static/badges/dinersclub_2_color_card.svg','https://trust.conversionbear.com/static/badges/paypal_2_color_card.svg','https://trust.conversionbear.com/static/badges/googlepay_color_card.svg','https://trust.conversionbear.com/static/badges/metapay_color_card.svg'
];
var container = document.createElement('div');
container.className = 'simple-checkout-container';
var imgContainer = document.createElement('div');
container.innerHTML = '<div class="logo-title">Secure Checkout With</div>';
imgContainer.className = 'simple-checkout-inner-container';
var y = document.querySelectorAll('.simple-badges-outer-container')[0];
if(document.getElementsByClassName('simple-checkout-container').length == 0){
  container.appendAfter(y);  
  container.appendChild(imgContainer);
  
}
    
for(var i = 0; i < imgSrcss.length; i++){
    console.log(imgSrcss[i]);
    var img = document.createElement('div');
    img.innerHTML = '<img src="'+imgSrcss[i]+'">'
    imgContainer.appendChild(img);
    img.className = "simple-logo-container";
           
    
}  
});   
}


var ur = window.location.href;
if(ur.includes('/product')){
jQuery(document).ready(function(){
    
  var btnClass = "button.product-form__submit.button";
  var selectorClass = "fieldset.js.product-form__input";
  var labels = "legend.form__label";
  var prodTitle = ".product__title h1";
  var prodPrice = ".product__info-wrapper.grid__item .price";

    
  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"><p></p></div><div class="simple-product-price"></div></div> <div class="simple-st-container__inner"> <div class="simple-select-container"> <div class="simple-st-select" id="st-select0"> <span>Color</span> <select> </select> </div><div class="simple-st-select" id="st-select1"> <span>Type</span> <select> </select> </div><div class="simple-st-select" id="st-select2"> <span>Type</span> <select> </select> </div></div><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('simple-st-container').length == 0){
  y[0].appendChild(sticky);
  
  
jQuery('.simple-product-name p').html(jQuery(prodTitle).eq(0).html());

setTimeout(function(){ 
jQuery('.simple-product-price').eq(0).html(jQuery(prodPrice).html());
}, 1000);
  
 
function populateOptions(select, labels){
  var selected = labels.eq(0).prop('selectedIndex');
  labels = labels.eq(0).find('input');
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
    
      var t = document.createTextNode(labels.eq(i).val());
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    if(labels.eq(i).attr('checked')){
      selected = i;
    }

    
  }
  
  select.selectedIndex = selected;
}
  
  jQuery('.simple-st-item__button').click(function(){
   if(!jQuery('.simple-st-item__button').hasClass("simple-st-disabled")){
     
      jQuery(btnClass).eq(0).click();
      }
    
   
  });
  
 if(jQuery(selectorClass).eq(0).length >= 1){
 
   jQuery('.simple-st-select span').eq(0).html(jQuery(labels).eq(0).html());
  jQuery('#st-select0').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select0').getElementsByTagName('select')[0], jQuery(selectorClass));
}
    
  
 if(jQuery(selectorClass).eq(1).length >= 1){
 
  jQuery('.simple-st-select span').eq(1).html(jQuery(labels).eq(1).html());
  jQuery('#st-select1').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select1').getElementsByTagName('select')[0], jQuery(selectorClass));
}
    
    
    
};
  
     function checkIfDisabled() {
         setTimeout(function () {
             var elem = jQuery(btnClass + ' span').eq(0);
             jQuery('.simple-st-item__button').html(elem.html());
             if (elem.html().toUpperCase().trim() != 'ADD TO CART') {
                 jQuery('.simple-st-item__button').html(elem.html());
                 jQuery('.simple-st-item__button').addClass('simple-st-disabled');
             } else {
                 jQuery('.simple-st-item__button').removeClass('simple-st-disabled');
             }
         }, 1000);
     }
//checkIfDisabled();

jQuery('#st-select0 > select').change(function(){
  checkIfDisabled();
  var i = jQuery(this).find(":selected").attr('id');
  jQuery('fieldset.js.product-form__input:eq(0) label').eq(i).click();
 
});
jQuery('#st-select1 > select').change(function(){
    checkIfDisabled();
 var i = jQuery(this).find(":selected").attr('id');
  jQuery('fieldset.js.product-form__input:eq(1) label').eq(i).click();
  
});

  
jQuery('fieldset.js.product-form__input:eq(0) input').click(function(){
checkIfDisabled();
 jQuery('#st-select0 > select').val(jQuery(this).val());
});
  
jQuery('fieldset.js.product-form__input:eq(1) input').click(function(){
  checkIfDisabled();
 jQuery('#st-select1 > select').val(jQuery(this).val());
});
  
    
    
  checkIfDisabled();
  
function isVisible(elem){
var elementTop = elem.offset().top;
var elementBottom = elementTop + elem.outerHeight();
var viewportTop = jQuery(window).scrollTop();
var viewportBottom = viewportTop + jQuery(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("simple-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('simple-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('simple-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery(btnClass).eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
});                             
}



var ur = window.location.href;
if(ur.includes('/collection')){
  $('.quick-add__submit').click(function(){
    var t = $(this);
   setTimeout(function(){ 
       var idd = t.parent().attr('data-modal');
if($(idd).attr('open') == null){
$(idd).attr('open', '');
}
}, 1000);
}); 
}